import { useCallback, useEffect } from "react";

export const useScrollLock = (ref, { enabled = true } = {}) => {
  const enforceScrollLock = useCallback((event) => {
    if (!enabled) {
      return;
    }
    const node = ref?.current;
    if (!node) {
      return;
    }

    const { deltaY } = event;
    const isScrollingDown = deltaY > 0;
    const isScrollingUp = deltaY < 0;
    const scrollTop = node.scrollTop;
    const maxScrollTop = node.scrollHeight - node.clientHeight;

    if (maxScrollTop <= 0) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const atTop = scrollTop <= 0;
    const atBottom = scrollTop >= maxScrollTop;

    if ((isScrollingUp && atTop) || (isScrollingDown && atBottom)) {
      const clampedScrollTop = Math.max(0, Math.min(maxScrollTop, scrollTop + deltaY));
      node.scrollTop = clampedScrollTop;
      event.preventDefault();
      event.stopPropagation();
    }
  }, [enabled, ref]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const node = ref?.current;
    if (!node) {
      return undefined;
    }

    const handleWheel = (event) => {
      enforceScrollLock(event);
    };

    node.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      node.removeEventListener("wheel", handleWheel);
    };
  }, [enabled, enforceScrollLock, ref]);
};

export default useScrollLock;
